import styled from "styled-components";
import React from "react";
import { COLORS } from "../contants/colors";
import { QUERIES } from "../contants/allConstants";
import { useLanguageContext } from "../languageContext";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useEffect } from "react";

const UserDetails = ({
  user,
  onClose,
  top = 0,
  isSupervisor = false,
  hideNestedData = false,
}) => {
  const { t } = useLanguageContext();
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState("ltr");

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  useEffect(() => setDirection(i18n.language === "ar" ? "rtl" : "ltr"), []);
  return (
    <Container>
      <Shadow top={top}>
        <Wrapper top={top} dir={direction}>
          <Head>
            <Icon
              onClick={() => onClose()}
              src={require("../images/whiteClose.svg").default}
              alt=""
            />
          </Head>
          <Row style={{ overflowY: "auto", height: "93%" }}>
            <Col>
              <User>
                <Avatar
                  dir={direction}
                  src={
                    user["image"] !== ""
                      ? user["image"]
                      : require("../images/avatar.svg").default
                  }
                />
                <div>
                  <Title>{user["name"] + " " + user["familyName"]}</Title>
                  {user["birthday"] && (
                    <Description>
                      {user["gender"] && (
                        <span>{t(user["gender"]) + " | "}</span>
                      )}
                      {getAge(user["birthday"]) + " " + t("yearsOld")}
                    </Description>
                  )}
                </div>
              </User>
              <div>
                {user.nationality && (
                  <Subrow>
                    <SubTitle>{t("nationality")}</SubTitle>
                    <SubDesc>{user.nationality}</SubDesc>
                  </Subrow>
                )}
                <Subrow>
                  <SubTitle>{t("country")}</SubTitle>
                  <SubDesc>{user.country}</SubDesc>
                </Subrow>
                {user.state && (
                  <Subrow>
                    <SubTitle>{t("state")}</SubTitle>
                    <SubDesc>{user.state}</SubDesc>
                  </Subrow>
                )}
                <Subrow>
                  <SubTitle>{t("phone")}</SubTitle>
                  <SubDesc
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      try {
                        document.createEvent("TouchEvent"); // if it's mobile/tablet or pc
                        window.open(`tel:${user.phone}`);
                        e.preventDefault();
                      } catch (e) {
                        return false;
                      }
                    }}
                    dir="ltr"
                  >
                    {user.phone}
                  </SubDesc>
                </Subrow>
                <Subrow>
                  <SubTitle>{t("email")}</SubTitle>
                  <SubDesc
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      window.location.href = `mailto:${user.email}`;
                      e.preventDefault();
                    }}
                  >
                    {user.email}
                  </SubDesc>
                </Subrow>
              </div>
            </Col>
            <Divider />
            <Col>
              <div>
                <GreenTitle>{t("join")}</GreenTitle>
                <p>{user.createdAt.split("T")[0]}</p>
              </div>

              {isSupervisor && user.teamName ? (
                <div>
                  <GreenTitle>{t("teamName")}</GreenTitle>
                  <p>{user.teamName}</p>
                </div>
              ) : null}
              {user.emergency_list.length > 0 &&
                !hideNestedData &&
                !isSupervisor && (
                  <div>
                    <GreenTitle>{t("emergency")}</GreenTitle>
                    <div style={{ height: "10px" }} />
                    <Subrow>
                      <div>
                        <WrapRow>
                          {user.emergency_list.map(
                            (item) =>
                              item.phone && (
                                <Square dir="ltr">
                                  {item.phone + " " + item.name}
                                </Square>
                              )
                          )}
                        </WrapRow>
                      </div>
                    </Subrow>
                  </div>
                )}
            </Col>
          </Row>
        </Wrapper>
      </Shadow>
    </Container>
  );
};
const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
`;
const Shadow = styled.div`
  background-color: ${COLORS.shadow};
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  height: 100vh;
  overflow-y: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // text-align: left;
  @media (${QUERIES.tabletAndDown}) {
    // height: max-content;
    height: 100%;
  }
`;
const Wrapper = styled.div`
  background-color: white;
  width: 90%;
  /* height: 90%; */
  border-radius: 10px;
  font-family: "Din";
  text-align: ${(p) => (p.dir == "ltr" ? "left" : "right")};
`;
const Divider = styled.div`
  width: 1px;
  background-color: ${COLORS.gray700};
  margin: 20px 0;
  @media (${QUERIES.tabletAndDown}) {
    display: none;
  }
`;
const Square = styled.p`
  background-color: ${COLORS.gray800};
  font-family: "Din";
  border-radius: 4px;
  font-weight: 400;
  font-size: 0.85rem;
  color: ${COLORS.black56};
  padding: 8px 10px;
  margin-top: 0;
  white-space: nowrap;
  margin-right: 6px;
`;
const Head = styled.div`
  width: 100%;
  height: 36px;
  background-color: ${COLORS.primary};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
const Icon = styled.img`
  width: 10px;
  height: 10px;
  object-fit: fill;
  cursor: pointer;
  float: right;
  margin: 12px 16px 0 0;
`;
const Col = styled.div`
  padding: 20px 30px 50px 20px;
  width: calc((90vw - 300px));
  /* width: calc((90vw - 300px) / 2); */

  @media (${QUERIES.tabletAndDown}) {
    width: 100%;
    padding: 10px 30px 0 20px;
  }
`;
const User = styled.div`
  display: flex;
  padding: 0;
  margin-bottom: 10px;
`;
const Row = styled.div`
  display: flex;
  padding: 0;
  @media (${QUERIES.tabletAndDown}) {
    flex-direction: column;
  }
`;
const Subrow = styled(Row)`
  align-items: baseline;
  @media (${QUERIES.tabletAndDown}) {
    flex-direction: row;
  }
`;
const WrapRow = styled(Row)`
  flex-wrap: wrap;
  @media (${QUERIES.tabletAndDown}) {
    flex-direction: row;
  }
`;
const Avatar = styled.img`
  border-radius: 50%;
  height: 84px;
  min-width: 84px;
  width: 84px;
  object-fit: cover;
  margin-right: ${(p) => (p.dir == "rtl" ? 0 : "30px")};
  margin-left: ${(p) => (p.dir == "rtl" ? "30px" : 0)};

  @media (${QUERIES.tabletAndDown}) {
    height: 64px;
    min-width: 64px;
    width: 64px;
  }
`;
const Title = styled.p`
  font-weight: 700;
  font-size: 1rem;
  color: ${COLORS.black56};
  margin: 10px 0 0 0;
  width: 100px;
  white-space: nowrap;
`;
const Description = styled.p`
  font-weight: 400;
  color: ${COLORS.black56};
  font-size: 1rem;
  margin: 15px 0 0 0;
  @media (${QUERIES.tabletAndDown}) {
    margin: 4px 0 0 0;
  }
`;
const SubTitle = styled(Title)`
  margin-top: 15px;
  min-width: 130px;
  font-size: 0.875rem;
`;
const SubDesc = styled(Description)`
  font-size: 0.875rem;
  word-wrap: break-word;
  width: max-content;
  overflow: auto;
`;
const GreenTitle = styled(Title)`
  color: ${COLORS.primary};
  margin: 5px 0 0 0;
`;
export default UserDetails;
